import { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom' // Import Link from react-router-dom
import { sidebarLinks } from '../../constants/sidebarRoutes'
import * as Icons from 'lucide-react'
import Logo from '../../assets/logo_png.svg'
import HrmLogo from '../../assets/hrmslogo.png'
import { componentRoutes } from '../../constants/componentRoutes'

// const NewSideBar = ({ open }) => {

//    // perfect working toggle----------------------------------------------------------------------------------------
//   const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
// //   const [open, setOpen] = useState(true);
// const [isActive, setIsActive] = useState(0);

// const toggleDropdown = (index) => {
//   setOpenDropdownIndex(openDropdownIndex === index ? null : index);
//   // setIsActive(index)
// };

// const handleActive = (e, index) => {
//    setIsActive(index);
// }

//     return (
//       <div
//         className={`app-menu ${
//           open ? "w-72" : "w-20 "
//         } h-screen bg-vertical-menu ltr:border-r rtl:border-l border-vertical-menu-border
//           fixed bottom-0 top-0 z-[1003] transition-all duration-75 ease-linear
//           md:block
//           `}
//           //   group-data-[sidebar-size=sm]:absolute group-data-[sidebar-size=sm]:z-10
//           //   group-data-[sidebar-size=sm]:top-0 group-data-[sidebar-size=sm]:left-0 group-data-[sidebar-size=sm]:w-full
//           //   group-data-[layout=horizontal]:w-full group-data-[layout=horizontal]:bottom-auto group-data-[layout=horizontal]:top-header
//       >
//         {/* <Icons.AArrowDown className={`absolute cursor-pointer -right-3 top-9 w-7 border-dark-purple text-black
//            border-2 rounded-full  ${!open && "rotate-180"}`}
//           onClick={() => setOpen(!open)} /> */}
//         {/* Sidebar Header with Logo */}
//         <Link to={componentRoutes.adminDashboard}>
//             <span>
//             {
//               open ? (
//                 <img src={HrmLogo} alt="Large Logo" className="w-40 h-35 transition-all duration-200 ease-in-out" style={{margin: "10px 15px"}} />
//               ) : (
//                 <img src={Logo} alt="Small Logo" className="w-10 h-10 transition-all duration-200 ease-in-out" style={{margin: "10px 15px"}} />
//               )
//             }
//             </span>
//           </Link>

//         {/* Scrollable Sidebar Links */}
//         <div>
//           {/* <ul className="flex flex-col">
//             {sidebarLinks.map((item, index) => {
//               const IconComponent = Icons[item.icon];
//               const hasChildren = item.children && item.children.length > 0;
//               return (
//                 <li key={index} className="relative">
//                   <div
//                     onClick={() => hasChildren && toggleDropdown(index)}
//                     className="relative flex items-center ltr:pl-3 rtl:pr-3 ltr:pr-5 rtl:pl-5 mx-3 my-1 group/menu-link text-vertical-menu-item-font-size font-normal transition-all duration-75 ease-linear rounded-md py-2.5 text-vertical-menu-item hover:text-vertical-menu-item-hover hover:bg-vertical-menu-item-bg-hover [&.active]:text-vertical-menu-item-active [&.active]:bg-vertical-menu-item-bg-active group-data-[sidebar=dark]:text-vertical-menu-item-dark group-data-[sidebar=dark]:hover:text-vertical-menu-item-hover-dark group-data-[sidebar=dark]:dark:hover:text-custom-500 group-data-[layout=horizontal]:dark:hover:text-custom-500 group-data-[sidebar=dark]:hover:bg-vertical-menu-item-bg-hover-dark group-data-[sidebar=dark]:dark:hover:bg-zink-600 group-data-[sidebar=dark]:[&.active]:text-vertical-menu-item-active-dark group-data-[sidebar=dark]:[&.active]:bg-vertical-menu-item-bg-active-dark group-data-[sidebar=brand]:text-vertical-menu-item-brand group-data-[sidebar=brand]:hover:text-vertical-menu-item-hover-brand group-data-[sidebar=brand]:hover:bg-vertical-menu-item-bg-hover-brand group-data-[sidebar=brand]:[&.active]:bg-vertical-menu-item-bg-active-brand group-data-[sidebar=brand]:[&.active]:text-vertical-menu-item-active-brand group-data-[sidebar=modern]:text-vertical-menu-item-modern group-data-[sidebar=modern]:hover:bg-vertical-menu-item-bg-hover-modern group-data-[sidebar=modern]:hover:text-vertical-menu-item-hover-modern group-data-[sidebar=modern]:[&.active]:bg-vertical-menu-item-bg-active-modern group-data-[sidebar=modern]:[&.active]:text-vertical-menu-item-active-modern group-data-[sidebar-size=md]:block group-data-[sidebar-size=md]:text-center group-data-[sidebar-size=sm]:group-hover/sm:w-[calc(theme('spacing.vertical-menu-sm')_*_3.63)] group-data-[sidebar-size=sm]:group-hover/sm:bg-vertical-menu group-data-[sidebar-size=sm]:group-data-[sidebar=dark]:group-hover/sm:bg-vertical-menu-dark group-data-[sidebar-size=sm]:group-data-[sidebar=modern]:group-hover/sm:bg-vertical-menu-border-modern group-data-[sidebar-size=sm]:group-data-[sidebar=brand]:group-hover/sm:bg-vertical-menu-brand group-data-[sidebar-size=sm]:my-0 group-data-[sidebar-size=sm]:rounded-b-none group-data-[layout=horizontal]:m-0 group-data-[layout=horizontal]:ltr:pr-8 group-data-[layout=horizontal]:rtl:pl-8 group-data-[layout=horizontal]:hover:bg-transparent group-data-[layout=horizontal]:[&.active]:bg-transparent cursor-pointer"
//                   >
//                     <IconComponent className="h-4 transition group-hover/menu-link:animate-icons fill-slate-100 group-hover/menu-link:fill-blue-200 group-data-[sidebar=brand]:fill-vertical-menu-item-bg-active-brand" />
//                     <span className={`ml-4 ${!open && "hidden"}`}>{item.label}</span>
//                     {hasChildren && (
//                       <Icons.ChevronDown
//                         className={`ml-auto transform ${openDropdownIndex === index ? 'rotate-90' : ''} ${!open && "hidden"}`}
//                         size={14}
//                       />
//                     )}
//                   </div>
//                 {!hasChildren && (
//                   <Link
//                   to={item.link}
//                   className="absolute inset-0" // Full area clickable
//                   />
//                 )} */}
//                 {/* Render as a Link if the item does not have children */}
//                 <ul className="flex flex-col">
//   {sidebarLinks.map((item, index) => {
//     const IconComponent = Icons[item.icon];
//     const hasChildren = item.children && item.children.length > 0;

//     // Check if the current item is active

//     return (
//       <li key={index} className='relative'
//       // className={`relative ${isActive === index ? "menu-active" : ""}`}
//       onClick={(e) => handleActive(e, index)}
//       >
//         {/* Conditionally wrap the div with a Link or render children */}
//         {hasChildren ? (
//           <div
//             onClick={() => hasChildren && toggleDropdown(index)}
//             className="relative flex items-center ltr:pl-3 rtl:pr-3 ltr:pr-5 rtl:pl-5 mx-3 my-1 group/menu-link text-vertical-menu-item-font-size font-normal transition-all duration-75 ease-linear rounded-md py-2.5 text-vertical-menu-item hover:text-vertical-menu-item-hover hover:bg-vertical-menu-item-bg-hover [&.active]:text-vertical-menu-item-active [&.active]:bg-vertical-menu-item-bg-active cursor-pointer"
//           >
//             <IconComponent className="h-4 transition group-hover/menu-link:animate-icons fill-slate-100 group-hover/menu-link:fill-blue-200 group-data-[sidebar=brand]:fill-vertical-menu-item-bg-active-brand" />
//             <span className={`ml-4 ${!open && "hidden"}`}>{item.label}</span>
//             {hasChildren && (
//               <Icons.ChevronDown
//                 className={`ml-auto transform ${
//                   openDropdownIndex === index ? "rotate-90" : ""
//                 } ${!open && "hidden"}`}
//                 size={14}
//               />
//             )}
//           </div>
//         ) : (
//           <Link
//             to={item.link}
//             className={`flex items-center ltr:pl-3 rtl:pr-3 ltr:pr-5 rtl:pl-5 mx-3 my-1 group/menu-link text-vertical-menu-item-font-size font-normal transition-all duration-75 ease-linear rounded-md py-2.5 text-vertical-menu-item hover:text-vertical-menu-item-hover hover:bg-vertical-menu-item-bg-hover [&.active]:text-vertical-menu-item-active [&.active]:bg-vertical-menu-item-bg-active cursor-pointer ${isActive === index ? "menu-active" : ""}`}
//           >
//             <IconComponent className="h-4 transition group-hover/menu-link:animate-icons fill-sky-100 group-hover/menu-link:fill-blue-200 group-data-[sidebar=brand]:fill-vertical-menu-item-bg-active-brand" />
//             <span className={`ml-4 ${!open && "hidden"}`}>{item.label}</span>
//           </Link>
//         )}

//                   {/* Dropdown Links */}
//                   {hasChildren && openDropdownIndex === index && (
//                     <ul
//                       className="pl-4 transition-all duration-300 ease-in-out"
//                       style={{ transitionProperty: 'max-height' }}
//                     >
//                       {item.children.map((child, childIndex) => (
//                         <li key={childIndex}>
//                           <Link
//                             to={child.link}
//                             className="relative flex items-center px-6 py-2 text-vertical-menu-item-font-size transition-all duration-75 ease-linear text-vertical-menu-sub-item hover:text-vertical-menu-sub-item-hover [&.active]:text-vertical-menu-sub-item-active before:absolute ltr:before:left-1.5 rtl:before:right-1.5 before:top-4 before:w-1 before:h-1 before:rounded before:transition-all before:duration-75 before:ease-linear before:bg-vertical-menu-sub-item hover:before:bg-vertical-menu-sub-item-hover [&.active]:before:bg-vertical-menu-sub-item-active group-data-[sidebar=dark]:text-vertical-menu-sub-item-dark group-data-[sidebar=dark]:dark:text-zink-200 group-data-[layout=horizontal]:dark:text-zink-200 group-data-[layout=horizontal]:dark:hover:text-custom-500 group-data-[sidebar=dark]:hover:text-vertical-menu-sub-item-hover-dark group-data-[sidebar=dark]:dark:hover:text-custom-500 group-data-[sidebar=dark]:[&.active]:text-vertical-menu-sub-item-active-dark group-data-[sidebar=dark]:dark:[&.active]:text-custom-500 group-data-[layout=horizontal]:dark:[&.active]:text-custom-500 group-data-[sidebar=dark]:before:bg-vertical-menu-sub-item-dark/50 group-data-[sidebar=dark]:hover:before:bg-vertical-menu-sub-item-hover-dark group-data-[sidebar=dark]:dark:hover:before:bg-custom-500 group-data-[sidebar=dark]:[&.active]:before:bg-vertical-menu-sub-item-active-dark group-data-[sidebar=dark]:dark:[&.active]:before:bg-custom-500 group-data-[sidebar=brand]:text-vertical-menu-sub-item-brand group-data-[sidebar=brand]:hover:text-vertical-menu-sub-item-hover-brand group-data-[sidebar=brand]:before:bg-vertical-menu-sub-item-brand/80 group-data-[sidebar=brand]:hover:before:bg-vertical-menu-sub-item-hover-brand/80 group-data-[sidebar=brand]:[&.active]:before:bg-vertical-menu-sub-item-active-brand/80 group-data-[sidebar=brand]:[&.active]:text-vertical-menu-sub-item-active-brand group-data-[sidebar=modern]:text-vertical-menu-sub-item-modern group-data-[sidebar=modern]:before:bg-vertical-menu-sub-item-modern/70 group-data-[sidebar=modern]:hover:text-vertical-menu-sub-item-hover-modern group-data-[sidebar=modern]:before:hover:bg-vertical-menu-sub-item-hover-modern group-data-[sidebar=modern]:[&.active]:text-vertical-menu-sub-item-active-modern group-data-[sidebar=modern]:before:[&.active]:text-vertical-menu-sub-item-active-modern group-data-[sidebar-size=md]:before:hidden group-data-[sidebar-size=md]:text-center group-data-[sidebar-size=md]:block group-data-[sidebar-size=sm]:before:hidden group-data-[layout=horizontal]:before:left-[1.4rem] group-data-[layout=horizontal]:md:before:hidden group-data-[layout=horizontal]:ltr:pl-10 group-data-[layout=horizontal]:rtl:pr-10 group-data-[layout=horizontal]:ltr:pr-5 group-data-[layout=horizontal]:rtl:pl-5 group-data-[layout=horizontal]:md:!px-5"
//                           >
//                             {child.label}
//                           </Link>
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </li>
//               );
//             })}
//           </ul>
//         </div>
//       </div>
//     );
// };

const NewSideBar = ({ open }) => {
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null)
  const location = useLocation() // Get the current location
  const currentPath = location.pathname // Get the current pathname
  const navigate = useNavigate();
  const toggleDropdown = index => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index)
  }

  const handleLogOut = (ele) => {
    sessionStorage.removeItem("code");
    navigate("/")
  }

  return (
    <div
      className={`app-menu ${open ? 'w-72' : 'w-20 '
        } h-screen bg-vertical-menu ltr:border-r rtl:border-l border-vertical-menu-border 
        fixed bottom-0 top-0 z-[1003] transition-all duration-75 ease-linear 
        md:block
      `}
    >
      <Link to={componentRoutes.adminDashboard}>
        <span>
          {open ? (
            <img
              src={Logo}
              alt='Large Logo'
              className='w-40 h-35 transition-all duration-200 ease-in-out'
              style={{ margin: '10px 15px' }}
            />
          ) : (
            <img
              src={Logo}
              alt='Small Logo'
              className='w-10 h-10 transition-all duration-200 ease-in-out'
              style={{ margin: '10px 15px' }}
            />
          )}
        </span>
      </Link>

      {/* Scrollable Sidebar Links */}
      <div
        className=' '
        style={{ height: '100%' }}
      >
        <ul className='flex flex-col relative h-full'>
          {sidebarLinks.map((item, index) => {
            const IconComponent = Icons[item.icon]
            const hasChildren = item.children && item.children.length > 0

            // Determine if the current item is active
            const isActive = currentPath === item.link
            return (

              <li key={index} className={` ${index === (sidebarLinks.length - 1) ? "logOutBtn" : "relative"}`}>
                {hasChildren ? (
                  <div
                    onClick={() => hasChildren && toggleDropdown(index)}
                    className={`relative flex items-center ltr:pl-3 rtl:pr-3 ltr:pr-5 rtl:pl-5 mx-3 my-1 group/menu-link text-vertical-menu-item-font-size font-normal transition-all duration-75 ease-linear rounded-md py-2.5 text-vertical-menu-item hover:text-vertical-menu-item-hover hover:bg-vertical-menu-item-bg-hover ${isActive ? 'menu-active' : ''
                      } cursor-pointer`}
                  >
                    <IconComponent className='h-4 transition group-hover/menu-link:animate-icons fill-slate-100 group-hover/menu-link:fill-blue-200 group-data-[sidebar=brand]:fill-vertical-menu-item-bg-active-brand' />
                    <span className={`ml-4 ${!open && 'hidden'}`}>
                      {item.label}
                    </span>
                    {hasChildren && (
                      <Icons.ChevronDown
                        className={`ml-auto transform ${openDropdownIndex === index ? 'rotate-90' : ''
                          } ${!open && 'hidden'}`}
                        size={14}
                      />
                    )}
                  </div>
                ) : (
                  <Link
                    to={item.link}
                    className={` flex items-center ltr:pl-3 rtl:pr-3 ltr:pr-5 rtl:pl-5 mx-3 my-1 group/menu-link text-vertical-menu-item-font-size font-normal transition-all duration-75 ease-linear rounded-md py-2.5 text-vertical-menu-item hover:text-vertical-menu-item-hover hover:bg-vertical-menu-item-bg-hover ${isActive ? 'menu-active' : ''
                      }`}
                    onClick={index === (sidebarLinks.length - 1) ? handleLogOut : undefined}
                  >
                    <IconComponent className='h-4 transition group-hover/menu-link:animate-icons fill-sky-100 group-hover/menu-link:fill-blue-200 group-data-[sidebar =brand]:fill-vertical-menu-item-bg-active-brand' />
                    <span className={`ml-4 ${!open && 'hidden'}`}>
                      {item.label}
                    </span>
                  </Link>
                )}

                {/* Dropdown Links */}
                {hasChildren && openDropdownIndex === index && (
                  <ul
                    className='pl-4 transition-all duration-300 ease-in-out'
                    style={{ transitionProperty: 'max-height' }}
                  >
                    {item.children.map((child, childIndex) => (
                      <li key={childIndex}>
                        <Link
                          to={child.link}
                          className={`relative flex items-center px-6 py-2 text-vertical-menu-item-font-size transition-all duration-75 ease-linear text-vertical-menu-sub-item hover:text-vertical-menu-sub-item-hover ${currentPath === child.link ? 'menu-active' : ''
                            }`}
                        >
                          {child.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default NewSideBar
